<div class="page">
  <app-page-header 
    itemName="" 
    page-title="{{ property.get('name') }}"
    isPropertyHome = "true"
    hideList = "{{ loggedUserShared }}"
  >
  </app-page-header>
  <div class="page-content">
    <div class="alert alert-danger text-center mb-4" *ngIf="propertyData && !propertyData.active">
      {{ 'properties.detail.suspended_property_alert' | translate }}
    </div>

    <!-- SUPPLIERS IN OUT -->
    <mat-card class="custom-card mt-4">
      <mat-card-title>{{ 'properties.propertySuppliersInOutList.title' | translate }}
      </mat-card-title>
      <mat-card-subtitle>{{ 'properties.propertySuppliersInOutList.title' | translate }}</mat-card-subtitle>
      <mat-card-content>
        <app-card-spinner [visible]="propertySuppliersInOutCardIsLoading" type="zero"></app-card-spinner>
        <mat-expansion-panel expanded="true" class="card-expansion-panel mat-elevation-z0">
          <mat-expansion-panel-header class="card-expansion-trigger"
            matTooltip="{{ 'common.words.toggleCard' | translate }}">
          </mat-expansion-panel-header>
          <div class="table-wrapper">
            <div class="table-toolbar">
              <div class="row align-items-center">
                <div class="col-12 col-sm-6 col-md-6">
                  <!-- <mat-form-field>
                    <input matInput placeholder="{{ 'common.words.search' | translate }}" #propertySuppliersInOutInput>
                    <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="resetInputPropertySuppliersInOut()"
                      class="reset-input-icon" *ngIf="propertySuppliersInOutInput.value"></mat-icon>
                  </mat-form-field> -->
                </div> 
                <div class="col-12 col-sm-6 col-md-6 text-right">
                  <button mat-button (click)="onExportPropertySuppliersInOut()" class="d-none d-sm-inline-block"
                    *ngIf="loggedUserPermissions.includes('canExportProperties')">
                    <mat-icon fontSet="fal" fontIcon="fa-download"></mat-icon>
                    {{ 'common.words.export' | translate }}
                  </button>
                  <button mat-button (click)="onResetFiltersPropertySuppliersInOut()" class="d-none d-sm-inline-block">
                    <mat-icon fontSet="fal" fontIcon="fa-broom"></mat-icon>
                    {{ 'common.cta.resetFilters' | translate }}
                  </button>
                </div> 
              </div> 
            </div> 
            <div class="is-loading" *ngIf="propertySuppliersInOutDataSource.loading$ | async">
              <mat-spinner diameter="50"></mat-spinner>
            </div>
            <div class="table-responsive">
              <table mat-table [dataSource]="propertySuppliersInOutDataSource" matSort #propertySuppliersInOutSort="matSort"
                matSortActive="tagNfcId" matSortDirection="asc" matSortDisableClear class="mat-elevation-z0">
                <ng-container matColumnDef="index">
                  <th mat-header-cell *matHeaderCellDef class="col-fixed-xxs">#</th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    {{ i + 1 }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <ng-container matColumnDef="tagNfcId">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-fixed-md">
                    {{ 'propertySuppliersInOut.fields.tagNfcId' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.tagNfcId.uid }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input matInput [formControl]="tagNfcIdFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilterPropertySuppliersInOut(tagNfcIdFilter)"
                        class="reset-input-icon" *ngIf="tagNfcIdFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="tagName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-fixed-md">
                    {{ 'propertySuppliersInOut.fields.tagName' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.tagNfcId.name }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input matInput [formControl]="tagNameFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilterPropertySuppliersInOut(tagNameFilter)"
                        class="reset-input-icon" *ngIf="tagNameFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="code">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-fixed-md">
                    {{ 'propertySuppliersInOut.fields.code' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.code }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter" *ngIf="filterOptionsLoaded">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input type="text" matInput [formControl]="codeFilter" [matAutocomplete]="operatorAuto">
                      <mat-autocomplete autoActiveFirstOption #operatorAuto="matAutocomplete"
                        [displayWith]="displayOperatorFn.bind(this)">
                        <mat-option *ngFor="let operator of filteredOperatorOptions" [value]="operator"
                          [style.opacity]="operator.deleted ? 0.6 : null"
                          (onSelectionChange)="onOperatorFilterSelected($event)">
                             {{ operator.code }}
                          <span *ngIf="operator.deleted" [style.color]="'#9e9e9e'"> ·
                            {{ 'propertySuppliersInOut.filters.deleted' | translate }}</span>
                        </mat-option>
                      </mat-autocomplete>
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilterPropertySuppliersInOut(codeFilter)"
                        class="reset-input-icon" *ngIf="codeFilter.value"></mat-icon>
                    </mat-form-field>
                    <mat-form-field class="filter" *ngIf="!filterOptionsLoaded">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input matInput [formControl]="codeFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilterPropertySuppliersInOut(codeFilter)"
                        class="reset-input-icon" *ngIf="codeFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="supplierId">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-fixed-md">
                    {{ 'propertySuppliersInOut.fields.supplierId' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                     <a class="ml-2" routerLink="../../../suppliers/detailv2/{{element.supplierId}}">
                      {{ element.supplierName }} 
                    </a>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter" *ngIf="filterOptionsLoaded">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input type="text" matInput [formControl]="supplierIdFilter" [matAutocomplete]="supplierAuto">
                      <mat-autocomplete autoActiveFirstOption #supplierAuto="matAutocomplete"
                        [displayWith]="displaySupplierFn.bind(this)">
                        <mat-option *ngFor="let supplier of filteredSupplierOptions" [value]="supplier"
                          [style.opacity]="supplier.deleted ? 0.6 : null"
                          (onSelectionChange)="onSupplierFilterSelected($event)">
                          {{ supplier.label }}<span *ngIf="supplier.deleted" [style.color]="'#9e9e9e'"> ·
                            {{ 'propertySuppliersInOut.filters.deleted' | translate }}</span>
                        </mat-option>
                      </mat-autocomplete>
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilterPropertySuppliersInOut(supplierIdFilter)"
                        class="reset-input-icon" *ngIf="supplierIdFilter.value"></mat-icon>
                    </mat-form-field>
                    <mat-form-field class="filter" *ngIf="!filterOptionsLoaded">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input matInput [formControl]="supplierIdFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilterPropertySuppliersInOut(supplierIdFilter)"
                        class="reset-input-icon" *ngIf="supplierIdFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="entrance">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-fixed-md">
                    {{ 'propertySuppliersInOut.fields.entranceA' | translate }}<br />
                    {{ 'propertySuppliersInOut.fields.entranceB' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.entrance | dateTimeFormat }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
                      <input matInput [matDatepicker]="dpEntrance" (focus)="dpEntrance.open()" (click)="dpEntrance.open()" readonly
                        placeholder="{{ 'common.cta.select' | translate }}" [formControl]="entranceFilter"
                        style="cursor: pointer" />
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times"
                        (click)="onResetFilterPropertySuppliersInOut(entranceFilter)" class="reset-input-icon"
                        *ngIf="entranceFilter.value"></mat-icon>
                      <mat-datepicker-toggle matSuffix [for]="dpEntrance"></mat-datepicker-toggle>
                      <mat-datepicker #dpEntrance></mat-datepicker>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="exit">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-fixed-md">
                    {{ 'propertySuppliersInOut.fields.exit' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.exit | dateTimeFormat }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
                      <input matInput [matDatepicker]="dpExit" (focus)="dpExit.open()" (click)="dpExit.open()" readonly
                        placeholder="{{ 'common.cta.select' | translate }}" [formControl]="exitFilter"
                        style="cursor: pointer" />
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times"
                        (click)="onResetFilterPropertySuppliersInOut(exitFilter)" class="reset-input-icon"
                        *ngIf="exitFilter.value"></mat-icon>
                      <mat-datepicker-toggle matSuffix [for]="dpExit"></mat-datepicker-toggle>
                      <mat-datepicker #dpExit></mat-datepicker>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="typeIn">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-fixed-md">
                    {{ 'propertySuppliersInOut.fields.typeA' | translate }}<br />
                    {{ 'propertySuppliersInOut.fields.typeB' | translate }}
                    <button mat-icon-button aria-label="Info" (mouseover)="onInfoTypePopUp()">
                      <mat-icon fontSet="fal" fontIcon="fa-info-circle" class="icon-action"></mat-icon>
                    </button>
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <span [style.color]="(element.typeIn === 'automatic' || element.typeIn === 'manual') ? '#dc3545' : null">
                      {{ 'propertySuppliersInOut.type.' + element.typeIn | translate }}
                    </span>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
                      <mat-select [formControl]="typeInFilter">
                        <mat-option>{{ 'common.words.all' | translate }}</mat-option>
                        <mat-option value="automatic">{{ 'propertySuppliersInOut.type.automatic' | translate }}</mat-option>
                        <mat-option value="manual">{{ 'propertySuppliersInOut.type.manual' | translate }}</mat-option>
                        <mat-option value="regular">{{ 'propertySuppliersInOut.type.regular' | translate }}</mat-option>
                      </mat-select>
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilterPropertySuppliersInOut(typeInFilter)"
                        class="reset-input-icon ml-n3" *ngIf="typeInFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="typeOut">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-fixed-md">
                    {{ 'propertySuppliersInOut.fields.typeA' | translate }}<br />
                    {{ 'propertySuppliersInOut.fields.typeB' | translate }}
                    <button mat-icon-button aria-label="Info" (mouseover)="onInfoTypePopUp()">
                      <mat-icon fontSet="fal" fontIcon="fa-info-circle" class="icon-action"></mat-icon>
                    </button>
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <span [style.color]="(element.typeOut === 'automatic' || element.typeOut === 'manual') ? '#dc3545' : null">
                      {{ 'propertySuppliersInOut.type.' + element.typeOut | translate }}
                    </span>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
                      <mat-select [formControl]="typeOutFilter">
                        <mat-option>{{ 'common.words.all' | translate }}</mat-option>
                        <mat-option value="automatic">{{ 'propertySuppliersInOut.type.automatic' | translate }}</mat-option>
                        <mat-option value="manual">{{ 'propertySuppliersInOut.type.manual' | translate }}</mat-option>
                        <mat-option value="regular">{{ 'propertySuppliersInOut.type.regular' | translate }}</mat-option>
                      </mat-select>
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilterPropertySuppliersInOut(typeOutFilter)"
                        class="reset-input-icon ml-n3" *ngIf="typeOutFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="duration">
                  <th mat-header-cell *matHeaderCellDef class="col-fixed-md">
                    {{ 'propertySuppliersInOut.fields.duration' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.duration | minutesToHoursFormat }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="propertySuppliersInOutDisplayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: propertySuppliersInOutDisplayedColumns; let i = index;"
                  [class.even-row]="(i % 2) == 0"></tr>
                <tr mat-footer-row *matFooterRowDef="propertySuppliersInOutDisplayedColumns"></tr>
              </table>
              <mat-paginator #propertySuppliersInOutPaginator [length]="propertySuppliersInOutDataSource.totalCount$ | async"
                [pageSizeOptions]="[10, 15, 20, 50, 75, 100]" showFirstLastButtons></mat-paginator>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-card-content>
    </mat-card>

  </div> <!-- /.page-content -->
</div> <!-- /.page -->